import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

const languages = [
  {
    flag: "fr",
    language: "fr",
    title: "Français"
  }
];

const messages = {
  fr: {
    Generic: {
      Search: "Rechercher",
      Actions: "Actions",
      Rows_per_page: "Lignes par page:",
      Name: "Nom",
      Add: "Ajouter",
      Cancel: "Annuler",
      Save: "Sauvegarder",
      Create: "Créer",
      Edit: "Éditer",
      Mail: "Mail",
      Yes: "Oui",
      No: "Non",
      Roles: "Rôles",
      Close: "Fermer",
      No_Data: "Aucune donnée",
      No_Data_Search: "Aucune donnée trouvée",
      Status: "Statut",
      NA: "N/A",
      Products: "Produits",
      Title: "Titre",
      Description: "Description",
      Confirm: "Confirmer",
      UserRights: {
        Admin: "Administer",
        Edit: "Éditer",
        View: "Voir"
      },
      Copy: "Copier"
    },
    Home: {
      Toolbar: {
        View_Profile: "Voir le profil",
        Logout: "Déconnexion"
      },
      NavigationDrawer: {
        User: {
          Name: "Utilisateur"
        },
        Common: {
          Name: "Outils",
          Dashboard: "Dashboard",
          DTAGenerator: "Générateur DTA"
        },
        Admin: {
          Name: "Admin",
          Manage_Users: "Gestion des utilisateurs",
          Manage_Sites: "Gestion des sites",
          Manage_Installers: "Gestion des installateurs"
        }
      }
    },
    Dashboard: {
      Title: "Dashboard",
      Sites_Title: "Sites et licences",
      Sites_Module: "Sites",
      License_Editor_Module: "Licences Editeur",
      License_Viewer_Module: "Licences Visualiseur"
    },
    Login: {
      Login: "Se connecter",
      Password: "Mot de passe",
      Forgot_password: "Mot de passe oublié ?",
      Remember_mail: "Se souvenir du mail ?"
    },
    ResetPassword: {
      Title: "Reinitialiser le mot de passe",
      NewPassword: "Nouveau mot de passe",
      ConfirmPassword: "Confirmer le nouveau mot de passe"
    },
    ForgotPassword: {
      Title: "Mot de passe oublié",
      Request_reset: "Réinitialiser le mot de passe"
    },
    Manage_Users: {
      Users: "Gérer les utilisateurs",
      User: " un nouvel utilisateur",
      Active_check: "Cet utilisateur est-il actif ?",
      Active: "Actif",
      Inactive: "Inactif",
      UserRightsTable: {
        SiteName: "Nom du site",
        AddAccess: "Ajouter un accès",
        NoSiteToDisplay: "Aucun site selectionnable"
      }
    },
    Manage_Sites: {
      Sites: "Gérer les sites",
      Site: " un nouveau site",
      SiteId: "ID du site",
      APIKey: "Clé d'API",
      StationId: "ID de la centrale",
      InverterId: "SN de l'onduleur",
      Installer: "Installateur",
      SolarEdge_Providers: "SolarEdge",
      Solplanet_Providers: "Solplanet",
      FusionSolar_Providers: "FusionSolar",
      FusionSolar_Access: "Clé associée",
      SiteProvidersTable: {
        AddProvider: "Ajouter un accès API"
      },
      Public_Access: "Accès public"
    },
    Manage_Installers: {
      Installers: "Gérer les installateurs",
      Installer: " un nouvel installateur",
      AddNewFusionSolarAccess: "Ajouter un nouvel accès FusionSolar",
      UserName: "Nom d'utilisateur",
      Password: "Mot de passe"
    },
    Installer_Details: {
      Add_FusionSolar_Access_Binding: "Ajouter une clé API"
    },
    Generate: {
      Generate_DTA: "Générer un fichier DTA",
      SiteId: "ID du site",
      APIKey: "Clé d'API",
      Validate: "Générer"
    },
    Profile: {
      Global: "Général",
      Details: "Détails"
    },
    Rules: {
      Name_required: "Le nom est requis",
      Password_required: "Le mot de passe est requis",
      Password_length: "Le mot de passe est trop court (8 caractères minimum)",
      Password_upper: "Le mot de passe doit contenir une lettre majuscule",
      Password_lower: "Le mot de passe doit contenir une lettre minuscule",
      Password_number: "Le mot de passe doit contenir un chiffre (0-9)",
      Mail_required: "Le mail est requis",
      NewPassword_required: "Un nouveau mot de passe est requis",
      ConfirmPassword_required: "Veuillez confirmer votre nouveau mot de passe",
      ConfirmPassword_invalid: "Les deux champs ne sont pas similaires",
      Mail_invalid: "Le mail est invalide",
      SiteId_generate_required: "L'ID du site est requis.",
      SiteId_required: "L'ID du site est requis et doit être unique.",
      APIKey_required: "La clé d'API est requise.",
      StationId_required: "L'ID de la centrale est requis et doit être unique.",
      InverterId_required: "Le SN de l'onduleur est requis.",
      Title_required: "Le titre est requis",
      Description_required: "La description est requise",
      Username_required: "Le nom d'utilisateur est requis."
    },
    Success: {
      Password_changed: "Votre mot de passe a bien été changé.",
      Change_request:
        "Un email pour changer votre mot de passe vous a été envoyé.",
      User_created: "L'utilisateur a été créé avec succès.",
      User_edited: "L'utilisateur a été édité avec succès.",
      User_state_changed: "Le statut de l'utilisateur a bien été changée.",
      Site_Created: "Le site a été créé avec succès.",
      Site_Edited: "Le site a été édité avec succès.",
      Installer_Created: "L'installateur a été créé avec succès."
    },
    Error: {
      Users_Not_Retrieved:
        "La liste des utilisateurs n'a pas pu être récupérée depuis le serveur.",
      User_state_changed:
        "Le statut de l'utlisateur n'a pas pu être sauvegardé.",
      User_Edition_Failed:
        "L'édition de l'utilisateur n'a pas pu être sauvegardé.",
      User_Creation_Failed:
        "L'utilisateur n'a pas pu être créé. Le mail et le nom doivent être uniques.",
      Login_Failed: "Utilisateur inconnu ou mot de passe incorrect.",
      Sites_Not_Retrieved:
        "La liste des sites n'a pas pu être récupérée depuis le serveur.",
      Installers_Not_Retrieved:
        "La liste des installateurs n'a pas pu être récupérée depuis le serveur.",
      Site_Creation_Failed:
        "Le site n'a pas pu être créé. L'ID du site doit etre unique.",
      Site_Edition_Failed: "L'édition du site n'a pas pu être sauvegardé.",
      Request_Reset_Failed:
        "La requête de réinitialisation n'a pas pu aboutir.",
      Password_Change_Failed: "Le mot de passe n'a pas pu être changé.",
      Installer_Creation_Failed: "L'installateur n'a pas pu être créé.",
      Installer_Not_Retrieved: "L'installateur demandé n'est pas accessible."
    }
  }
};

const i18n = new VueI18n({
  locale: "fr",
  fallbackLocale: "fr",
  messages
});

export { languages, i18n };
